import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  BillingVisibility,
  FrontendPaidFeatureService,
} from '../../frontend-paid-feature.service';
import { PricePlansRestrictionsService } from '@tablesready/frontend-restrictions';
import { AuthUser } from '@shared/signup/models';

@Component({
  selector: 'frontend-paid-feature[user]',
  templateUrl: './frontend-paid-feature.component.html',
  standalone: false,
})
export class FrontendPaidFeatureComponent implements OnChanges {
  @Input() visibility?: BillingVisibility;
  @Input() user?: AuthUser;

  isVisible = false;

  constructor(
    private readonly restrictionsService: PricePlansRestrictionsService,
    readonly paidService: FrontendPaidFeatureService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && this.user) {
      this.paidService.setUser(this.user);
      this.setVisibility();
    }

    if (changes['visibility'] && this.visibility) {
      if (this.user) {
        this.paidService.setUser(this.user);
      }
      this.setVisibility();
    }
  }

  private setVisibility(): void {
    if (this.visibility === BillingVisibility.FULL) {
      this.isVisible = true;
      return;
    }

    if (this.visibility === BillingVisibility.HIDDEN_ON_MOBILE) {
      this.isVisible = false;
      return;
    }

    if (this.visibility !== undefined) {
      this.isVisible = this.paidService.billingsVisibility === this.visibility;
      return;
    }

    if (
      this.paidService.billingsVisibility === BillingVisibility.FULL ||
      this.paidService.billingsVisibility === BillingVisibility.LINKS_ONLY_ON_MOBILE
    ) {
      this.isVisible = true;
      return;
    }

    if (
      this.paidService.billingsVisibility === BillingVisibility.BUSINESS_PLAN_OUTSIDE_US &&
      this.user && this.user.account && this.user.location &&
      this.restrictionsService.availableForBusinessPlan(
        this.user.account.subscriptionType,
        this.user.location.recurly
      )
    ) {
      this.isVisible = true;
      return;
    }

    this.isVisible = false;
  }
}
